export const getToastWording = (filetype: 'excel' | 'pdf', statementType: string) => {
  const filetypeStr = filetype === 'excel' ? 'excel sheet' : 'pdf file';

  return {
    message: `${statementType} ${filetypeStr} will be available in your downloads folder when the download is complete.`,
    title: `${filetype === 'excel' ? 'Excel sheet' : 'PDF'} downloading...`,
    successMessage: `${statementType} ${filetypeStr} successfully downloaded.`,
    errorMessage: `${statementType} ${filetypeStr} download failed.`,
    promiseCompleteTitle: `${filetype === 'excel' ? 'Excel' : 'PDF'} document download`
  };
};

export const getClientListDownloadToastWording = () => ({
  message:
    'Clients list will be available in your downloads folder when the download is complete.',
  title: 'Excel sheet downloading...',
  successMessage: 'Clients list successfully downloaded.',
  errorMessage: 'Clients list download failed.',
  promiseCompleteTitle: 'Excel document download'
});
